"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findItemsDominio = exports.ItemDeDominio = void 0;
const core_1 = require("./core");
var ItemDeDominio;
(function (ItemDeDominio) {
    ItemDeDominio["NIVEL_ACESSO_USUARIO"] = "nivelAcessoUsuario";
    ItemDeDominio["ARR_FORMA_PGTO"] = "arrFormaPgto";
    ItemDeDominio["ARR_FORMA_PGTO_ABREV"] = "arrFormaPgtoAbrev";
    ItemDeDominio["ARR_DIAS_SEMANA"] = "arrDiasSemana";
    ItemDeDominio["ARR_MES"] = "arrMes";
    ItemDeDominio["STATUS_PADRAO"] = "statusPadrao";
    ItemDeDominio["TIPO_PLANO"] = "tipoPlano";
    ItemDeDominio["ARR_TIPO_PESSOA"] = "arrTipoPessoa";
    ItemDeDominio["FLG_PADRAO"] = "flgPadrao";
    ItemDeDominio["ARR_SEXO"] = "arrSexo";
    ItemDeDominio["STS_PAGAMENTO"] = "stsPagamento";
    ItemDeDominio["COMBO_ESTADO"] = "comboEstado";
    ItemDeDominio["ARR_TIPO_MENSAGEM"] = "arrTipoMensagem";
    ItemDeDominio["ARR_TIPO_GARANTIA"] = "arrTipoGarantia";
    ItemDeDominio["ARR_TIPO_ANEXO"] = "arrTipoAnexo";
    ItemDeDominio["STATUS_CONTRATO"] = "statusContrato";
    ItemDeDominio["ARR_TIPO_FATURA"] = "arrTipoFatura";
    ItemDeDominio["ARR_DATA_FILTRO_RECB"] = "arrDataFiltroReceb";
    ItemDeDominio["STATUS_MENSAGEM"] = "arrStatusMensagem";
    ItemDeDominio["TIPO_ENVIO_MENSAGEM"] = "tipoEnvioMensagem";
    ItemDeDominio["TIPO_ITEM_CONTRATO"] = "arrTipoItemContrato";
})(ItemDeDominio = exports.ItemDeDominio || (exports.ItemDeDominio = {}));
function findItemsDominio(item) {
    return core_1.get('itemDominio', item)
        .then(({ dados }) => dados.map(item => ({
        key: item.key,
        valor: item.valor
    })));
}
exports.findItemsDominio = findItemsDominio;
